import auth from "./auth"
import dashboard from "./dashboard"

const routes = [
    ...auth,
    ...dashboard,
]

export default routes
